import React from 'react';
import { CtaButton } from './CtaButton';
import { FrameworkFlow } from './FrameworkFlow';
import { IMAGES } from '../data/toolkit';
export function Hero() {
  return <header className="border-b border-navy-line bg-ivory" data-id="element-48" data-mp="ei1vtn9me4yh">
      <div className="mx-auto w-full max-w-[42rem] px-4 pb-9 pt-7 text-center sm:px-6 sm:pb-12 sm:pt-10 lg:max-w-3xl lg:pb-16 lg:pt-14" data-id="element-49" data-mp="9ll64omrvija">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-50" data-mp="4jvw9cbadaws">
          Professional Occupational Therapy Resource System
        </p>

        <h1 className="mt-4 font-display text-[2.05rem] font-medium leading-[1.1] tracking-tight text-navy sm:text-[2.75rem] lg:text-[3.15rem]" data-id="element-51" data-mp="xaxfppm0hsm4">
          The Complete Clinical Planning System for Occupational Therapists
        </h1>

        <p className="mx-auto mt-3.5 max-w-[36rem] text-[0.98rem] leading-relaxed text-navy-muted sm:text-[1.05rem]" data-id="element-52" data-mp="nekl8pin7aqb">
          Save hours planning sessions, organizing assessments, choosing
          interventions, documenting progress and preparing clinical resources —
          without rebuilding your workflow from scratch.
        </p>

        <img src={IMAGES.bundle} alt="The complete OT Clinical Toolkit™ bundle: six clinical volumes with printed worksheets, quick reference cards and a tablet." className="mx-auto -mb-1 mt-4 w-full max-w-[27rem] sm:mt-6 sm:max-w-[30rem] lg:max-w-[33rem]" width={1520} height={1030} data-id="element-53" data-mp="3o7vhbcfrj9tl" />

        <p className="mt-4 text-[0.7rem] font-bold uppercase tracking-[0.18em] text-navy" data-id="element-54" data-mp="30fya5yn9d5yt">
          OT Clinical Toolkit™
        </p>

        <p className="mt-2 text-[0.98rem] font-semibold leading-snug text-navy sm:text-[1.05rem]" data-id="element-55" data-mp="2qkdd8ex1qvvx">
          6 Professional Clinical Volumes{' '}
          <span className="text-teal" aria-hidden="true" data-id="element-56" data-mp="2vjg9payyntsa">
            +
          </span>{' '}
          5 Practical Bonus Resources
        </p>

        <FrameworkFlow className="mt-3.5" data-id="element-57" data-mp="2lkike5tpnw88" />

        <CtaButton label="Get OT Clinical Toolkit™" size="lg" className="mt-6" data-id="element-58" data-mp="2lk8uei8o1p2j" />
        <p className="mt-2.5 text-[0.8rem] text-navy-muted" data-id="element-59" data-mp="s44hnmgsjjhd">
          Instant digital access • One-time payment
        </p>
      </div>
    </header>;
}